import React from "react"
import autobind from "class-autobind"
import { Dialog, FlatButton } from "material-ui"
import FinddDatePicker from "../common/FinddDatePicker"
import strings from "../../localization/strings"
import { IDate, ICustomReportDocument, INewCustomReportParameters, EDateSelectionType } from "../../models"
import DateRangeSelect from "../../components/common/DateRangeSelect"
import * as reportAction from "../../actions/ReportAction"
import { blueGrey500 } from "material-ui/styles/colors"
import moment from "moment"
import TimecardDateRange from "../timecard/TimecardDateRange"
import * as timeHelper from "../../helpers/timeHelper"

interface IProps {
    newCustomReportDoc: ICustomReportDocument
    newCustomReportParameters: INewCustomReportParameters
    handleClose(): void
}
interface IState {
    // date1 and date2 are browser time
    date1: IDate
    date2: IDate
    isValid: boolean
}

export default class NewCustomReportDialog extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            date1: this.props.newCustomReportParameters.Date1,
            date2: this.props.newCustomReportParameters.Date2,
            isValid: this.props.newCustomReportDoc.DateSelectionType === EDateSelectionType.NoSelection
        }
        autobind(this)
    }

    handleDownload() {
        if (!this.state.isValid) return
        this.props.handleClose()
        const { newCustomReportParameters } = this.props
        if (this.props.newCustomReportDoc.DateSelectionType === EDateSelectionType.NoSelection) {
            newCustomReportParameters.Date1 = null
            newCustomReportParameters.Date2 = null
        }
        else if (this.props.newCustomReportDoc.DateSelectionType === EDateSelectionType.SingleDate) {
            newCustomReportParameters.Date1 = moment(this.state.date1).utc(true).format()
            newCustomReportParameters.Date2 = null
        }
        else if (this.props.newCustomReportDoc.DateSelectionType === EDateSelectionType.DateRange) {
            newCustomReportParameters.Date1 = moment(this.state.date1).utc(true).format()
            newCustomReportParameters.Date2 = moment(this.state.date2).utc(true).format()
        }
        else if (this.props.newCustomReportDoc.DateSelectionType === EDateSelectionType.Weekly) {
            newCustomReportParameters.Date1 = moment(this.state.date1).utc(true).format()
            newCustomReportParameters.Date2 = null
        }

        reportAction.downloadNewCustomReport(this.props.newCustomReportDoc.Id, this.props.newCustomReportParameters)
    }

    render() {
        return (
            <Dialog
                open
                title={this.props.newCustomReportDoc.Name}
                actions={[
                    <FlatButton data-intercom-target={"New-Custom-Report-Btn-Close"} key="cancel" label={strings.CANCEL} secondary onTouchTap={this.props.handleClose} />,
                    <FlatButton data-intercom-target={"New-Custom-Report-Btn-Download"} key="download" label={strings.Download} disabled={!this.state.isValid} primary onTouchTap={this.handleDownload} />
                ]}
            >
                {this.props.newCustomReportDoc.DateSelectionType === EDateSelectionType.NoSelection ?
                    strings.Are_you_sure_you_want_to_download :
                    this.props.newCustomReportDoc.DateSelectionType === EDateSelectionType.SingleDate ?
                        <FinddDatePicker
                            value={this.state.date1}
                            onChange={(e, value) => this.setState({ date1: value, isValid: true })}
                            floatingLabelText={strings.ReportDate}
                            cancelLabel={<span style={{ color: blueGrey500 }}>{strings.Cancel}</span>}
                            firstDayOfWeek={0}
                        /> :
                        this.props.newCustomReportDoc.DateSelectionType === EDateSelectionType.DateRange ?
                            <DateRangeSelect
                                startDate={moment(this.state.date1).utc(true)}
                                endDate={moment(this.state.date2).utc(true)}
                                handleChange={(startDate, endDate, isValid) => this.setState({ date1: timeHelper.keepConvertUTCToLocal(startDate), date2: timeHelper.keepConvertUTCToLocal(endDate), isValid })}
                                sameDatesAllowed
                            /> :
                            this.props.newCustomReportDoc.DateSelectionType === EDateSelectionType.Weekly &&
                            <TimecardDateRange
                                referenceDate={this.state.date1}
                                payGroupId={this.props.newCustomReportParameters.UserPayGroupId || this.props.newCustomReportParameters.PayGroupIds[0]}
                                handleChangeReferenceDate={referenceDate => this.setState({ date1: referenceDate, isValid: true })}
                            />
                }
            </Dialog>
        )
    }
}